import React from 'react';
import { Tree as TreeNew } from './Tree';
import { convertOldTreeProps } from './converter.old';
import type { OldTreeProps } from './converter.old';

export type TreeProps = OldTreeProps;

export const Tree: React.FC<TreeProps> = (props) => <TreeNew {...convertOldTreeProps(props)} />;
